module.exports = __webpack_public_path__ + "videos/organize.6da3351.mp4";